import { AlertSource } from '@app/alerts/state/alerts-state.models';
import { GetDrawerAlerts, GetPageAlerts } from '@app/alerts/state/alerts-state.actions';

export function getActionFromSource(source: AlertSource): any {
  return source === 'drawer' ? GetDrawerAlerts : GetPageAlerts;
}
